export default __webpack_public_path__ + "static/media/vanco-auc.bebe6b44.png";